import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import PersonDetails from "@/shared/model/personDetails";
import {getOrderTypes} from "@/shared/model/orderType";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import SogSwitch from "@/shared/ui/SogSwitch.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import {useAccountStore} from "@/stores/accountStore";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import SogScheduleSerie from "@/shared/ui/SogScheduleSerie.vue";
import {Action} from "@/shared/model/Action";

interface Props {
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonAccountingFormComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props

const _accountStore = useAccountStore();


const _form = ref<InstanceType<typeof SogForm> | null>(null)


const _orderTypeId = ref("")
const _withoutCreditLimit = ref<boolean>(false)
const _creditLimit = ref<number | undefined>(0)
const _email = ref<string | undefined>(undefined)
const _invoiceCircle = ref<string | undefined>(undefined)
const _nextInvoiceDate = ref<Date | undefined>(undefined)
const _invoiceDueDate = ref<string | undefined>(undefined)
const _orderingBlocking = ref<boolean | undefined>(false)
const _automaticCancelationInvoicing = ref<boolean | undefined>(false)
const _cancellationAllowedWithoutPayment = ref<boolean | undefined>(false)

const _validations: SogFormValidationRule[] = [
  {name: 'email', rules: {email: true}},
]

watch(props, () => {
  _orderTypeId.value = props.details?.getValue(PersonDetailsId.OrderTypeId)
  _email.value = props.details?.getValue(PersonDetailsId.OrderEmail)
  _invoiceCircle.value = props.details?.getValue(PersonDetailsId.InvoiceCircle)
  _creditLimit.value = props.details?.getNumberValue(PersonDetailsId.CreditLimit)
  _nextInvoiceDate.value = props.details?.getValue(PersonDetailsId.OrderScheduleNext)
  _invoiceDueDate.value = props.details?.getValue(PersonDetailsId.InvoiceDueDate)
  _withoutCreditLimit.value = props.details?.getBooleanValue(PersonDetailsId.WithoutCreditLimit) ?? false
  _orderingBlocking.value = props.details?.getBooleanValue(PersonDetailsId.OrderingBlocking) ?? false
  _automaticCancelationInvoicing.value = props.details?.getBooleanWithDefaultValue(PersonDetailsId.AutomaticCancelationInvoicing, true)
  _cancellationAllowedWithoutPayment.value = props.details?.getBooleanValue(PersonDetailsId.CancellationAllowedWithoutPayment) ?? false
}, {immediate: true})


function validate(): boolean {
  return _form.value?.validate() ?? false;
}

function getDetails(): PersonDetails {
  const res = new PersonDetails(props?.details?.getValues())
  res.setValue(PersonDetailsId.OrderTypeId, _orderTypeId.value)
  res.setValue(PersonDetailsId.OrderEmail, _email.value)
  res.setValue(PersonDetailsId.InvoiceCircle, _invoiceCircle.value)
  res.setValue(PersonDetailsId.InvoiceDueDate, _invoiceDueDate.value)
  res.setNumberValue(PersonDetailsId.CreditLimit, _creditLimit.value ?? 0)
  res.setBooleanValue(PersonDetailsId.WithoutCreditLimit, _withoutCreditLimit.value ?? false)
  res.setBooleanValue(PersonDetailsId.OrderingBlocking, _orderingBlocking.value ?? false)
  res.setBooleanValue(PersonDetailsId.AutomaticCancelationInvoicing, _automaticCancelationInvoicing.value ?? true)
  res.setBooleanValue(PersonDetailsId.CancellationAllowedWithoutPayment, _cancellationAllowedWithoutPayment.value ?? false)
  return res;
}

__expose({
  getDetails, validate
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form,
    validations: _validations
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogSwitch, {
            modelValue: _orderingBlocking.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_orderingBlocking).value = $event)),
            placeholder: "Bestellmöglichkeit gesperrt"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(_accountStore).hasAction(_unref(Action).OrderingBlocking)]
      ]),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogDropDownList, {
            modelValue: _orderTypeId.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_orderTypeId).value = $event)),
            placeholder: "Rechnungstyp",
            "data-source": _unref(getOrderTypes)()
          }, null, 8, ["modelValue", "data-source"])
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _invoiceCircle.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_invoiceCircle).value = $event)),
              placeholder: "Rechnungsreferenznummer",
              name: "Rechnungsreferenznummer"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _email.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_email).value = $event)),
              placeholder: "Rechnungs-Email",
              name: "email"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(_accountStore).hasAccountingLicense()]
        ]),
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogSwitch, {
              modelValue: _withoutCreditLimit.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_withoutCreditLimit).value = $event)),
              placeholder: "ohne Kreditlimit"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(_accountStore).hasAccountingLicense()]
        ]),
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogSwitch, {
              modelValue: _automaticCancelationInvoicing.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_automaticCancelationInvoicing).value = $event)),
              placeholder: "Automatische Stornoabrechnung"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _orderTypeId.value === 'AccumulativeInvoice']
        ]),
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogSwitch, {
              modelValue: _cancellationAllowedWithoutPayment.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_cancellationAllowedWithoutPayment).value = $event)),
              placeholder: "Stornogenehmigung ohne Bezahlung"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _orderTypeId.value === 'AccumulativeInvoice']
        ]),
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogNumericTextBox, {
              modelValue: _creditLimit.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_creditLimit).value = $event)),
              placeholder: "Betrag, €"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(_accountStore).hasAccountingLicense()&&!_withoutCreditLimit.value]
        ]),
        _createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _invoiceDueDate.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_invoiceDueDate).value = $event)),
              placeholder: "Rechnungsfälligkeit"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogDatePicker, {
            modelValue: _nextInvoiceDate.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_nextInvoiceDate).value = $event)),
            width: "100%",
            format: "dd.MM.yyyy HH:mm",
            placeholder: "Nächste Rechnung am"
          }, null, 8, ["modelValue"]),
          _createVNode(SogScheduleSerie, { "next-invoice-date": _nextInvoiceDate.value }, null, 8, ["next-invoice-date"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _orderTypeId.value==='AccumulativeInvoice']
      ])
    ]),
    _: 1
  }, 512))
}
}

})